import React, { PureComponent } from 'react';
import './WidgetMunicipal48h.css';
import PropTypes from 'prop-types';
import Header from '../../partials/Header/Header';
import Nav from '../../partials/Nav/Nav';
import DayNav from '../../partials/DayNav/DayNav';
import { DataViz } from '../../partials/DataViz/DataViz';
import Humidity from '../../partials/Humidity';
import TemperaturePerceived from '../../partials/TemperaturePerceived';
import Temperature from '../../partials/Temperature';
import Sky from '../../partials/Sky';
import WindSpeed from '../../partials/WindSpeed';
import WindDirection from '../../partials/WindDirection';
import { dayNavColor } from '../../utils/utils';
import { translate } from '../../utils/translations';
import Loader from '../../partials/Loader/Loader';
import logo from '../../img/logo.png';

export class WidgetMunicipal48h extends PureComponent {
    state = {
        day: 0,
        rerenderChart: true,
    };

    static propTypes = {
        config: PropTypes.shape({
            location: PropTypes.string,
            language: PropTypes.string,
            color: PropTypes.string,
            variables: PropTypes.arrayOf(PropTypes.string),
            startDay: PropTypes.object,
            interval: PropTypes.number,
        }),
        data: PropTypes.object,
        widgetDate: PropTypes.string,
    };

    render() {
        const {
            color,
            location,
            alternativeTitle,
            language,
            mainChart,
            secondaryChart,
            tempFormat,
            windSpeedFormat,
        } = this.props.config;

        const {
            temp,
            est_cel,
            prec_acu,
            vent_velo,
            vent_dir,
            hum_rel,
            temp_xaf,
        } = this.props.data;

        const dayIndex = this.state.day + 1;

        if (!this.props.data.est_cel) {
            return <Loader language={this.props.config.language} />;
        }

        return (
            <div
                className="WidgetMunicipal48h mc-widget"
                style={{ color: 'red' }}
            >
                <Header color={color} logo={logo} />
                <div className="mc-widget-wrapper">
                    <Nav
                        locationCode={location}
                        alternativeTitle={alternativeTitle}
                        cities={this.props.cities}
                        language={language}
                        widgetDate={this.props.widgetDate}
                    />
                    <DayNav
                        language={language}
                        numberOfDays={2}
                        currentDay={this.state.day}
                        dayNavigation={this.dayNavigation}
                        color={dayNavColor(color)}
                    />
                    {!temp[1] ? (
                        <p>{translate(language, 'no_data')}</p>
                    ) : (
                        <div className="mc-widget-content">
                            <DataViz
                                location={location}
                                language={language}
                                temp={temp[dayIndex]}
                                estCel={est_cel[dayIndex]}
                                precAcu={prec_acu[dayIndex]}
                                ventVelo={vent_velo[dayIndex]}
                                ventDir={vent_dir[dayIndex]}
                                mainChart={mainChart}
                                secondaryChart={secondaryChart}
                                rerenderChart={this.state.rerenderChart}
                                day={this.state.day}
                                tempFormat={tempFormat}
                                windSpeedFormat={windSpeedFormat}
                            />
                            {mainChart === 'vent' && (
                                <Sky
                                    language={language}
                                    data={est_cel[dayIndex]}
                                />
                            )}
                            {mainChart === 'vent' && (
                                <Temperature
                                    language={language}
                                    data={temp[dayIndex]}
                                    tempFormat={tempFormat}
                                />
                            )}
                            <Humidity
                                language={language}
                                data={hum_rel[dayIndex]}
                            />
                            <TemperaturePerceived
                                language={language}
                                data={temp_xaf[dayIndex]}
                                tempFormat={tempFormat}
                                mainChart={mainChart}
                            />
                            {mainChart === 'estCel' && (
                                <WindSpeed
                                    language={language}
                                    data={vent_velo[dayIndex]}
                                    windSpeedFormat={windSpeedFormat}
                                />
                            )}
                            {mainChart === 'estCel' && (
                                <WindDirection
                                    language={language}
                                    data={vent_dir[dayIndex]}
                                    speed={vent_velo[dayIndex]}
                                    speedFormat={windSpeedFormat}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        const config = this.props.config;

        // If relevant inputs are updated (relevant = chart is affected by)
        if (
            this.state.day !== prevState.day ||
            (config.location !== prevProps.config.location &&
                config.location !== '') ||
            config.tempFormat !== prevProps.config.tempFormat ||
            config.windSpeedFormat !== prevProps.config.windSpeedFormat ||
            this.props.mainChart !== prevProps.mainChart ||
            this.props.secondaryChart !== prevProps.secondaryChart
        ) {
            this.setState({ rerenderChart: true });
        }

        // If not relevant fields are updated, we don't want the chart to rerender
        else if (
            config.alternativeTitle !== prevProps.config.alternativeTitle ||
            config.language !== prevProps.config.language ||
            config.color !== prevProps.config.color
        ) {
            this.setState({ rerenderChart: false });
        }
    }

    dayNavigation = day => {
        this.setState({ day });
    };
}



// WEBPACK FOOTER //
// ./src/widgets/Municipal48h/WidgetMunicipal48h.js